import * as React from "react"
import DetailServiceModalComponent, { Names } from "./detail-service-modal-component"
import { Service, LocalAuthority, ServiceGroup, ElementAnalytiqueBergerLevrault, User } from "../../../model"
import * as ServicesService from "../../../service/sfp/services-service"

export default class DetailServiceModal
    extends React.Component<DetailServiceModalProps, State> {
    private abortController = new AbortController

    constructor(props: DetailServiceModalProps) {
        super(props)
        this.state = {
            agents: [],
            agentsLoaded: false,
            loadingAgents: false,
            loadingService: false,
            selectedServiceBL: undefined,
            service: props.service,
            serviceLoaded: false,
            submitting: false
        }
    }

    componentDidMount() {
        this.initData(this.props)
    }

    componentWillReceiveProps(props) {
        this.initData(props)
    }

    componentWillUnmount() {
        this.abortController.abort()
    }

    render() {
        const bergerLevrault = this.props.localAuthority.bergerLevrault
        return <DetailServiceModalComponent
            agents={this.state.agents}
            bergerLevrault={bergerLevrault}
            loadingAgents={this.state.loadingAgents}
            loadingServicesBL={this.props.loading}
            loadingService={this.state.loadingService}
            localAuthority={this.props.localAuthority}
            groups={this.props.groups}
            Politique={this.props.Politique}
            service={this.state.service}
            servicesBL={this.props.servicesBL}
            selectedServiceBL={this.state.selectedServiceBL}
            submitting={this.state.submitting}
            onChangeServiceBL={(s) => this.handleChangeServiceBL(s)}
            onClickCloseButton={this.props.onClose}
            onClickFooterButton={(b, e) => this.props.onClose(e)}
            onSubmit={e => this.handleSubmit(e)} />
    }

    private createService(values: FormValues): void {
        let approaches = values.approaches ? values.approaches[0] !== null ? values.approaches : [] : []
        ServicesService.createService(
            this.props.localAuthority, values.label, values.code, values.group, values.description, approaches)
            .then(service => {
                this.setState({ submitting: false })
                this.props.onServiceCreated(service)
            })
            .catch(reason => {
                this.setState({ submitting: false })
                this.props.onError(reason)
            })
    }

    private forcefetchingServiceAgents(): void {
        this.setState({
            agents: [],
            agentsLoaded: false,
            loadingAgents: true
        }, () => {
            ServicesService.findAgents(this.state.service, this.abortController.signal)
                .then(agents => {
                    this.setState({
                        agents,
                        agentsLoaded: true,
                        loadingAgents: false
                    })
                }
                )
        })
    }

    private getCodeValue(formData: FormData): string {
        return formData.get(Names.Code).toString()
    }

    private getDescriptionValue(formData: FormData): string {
        return formData.get(Names.Description).toString()
    }

    private getFormValues(form: HTMLFormElement): FormValues {
        const formData = new FormData(form)
        return {
            code: this.getCodeValue(formData),
            description: this.getDescriptionValue(formData),
            label: this.getLabelValue(formData),
            group: this.getGroupValue(formData),
            approaches: this.getapproaches(formData),
        }
    }

    private getLabelValue(formData: FormData): string {
        return formData.get(Names.Label).toString()
    }

    private getGroupValue(formdata: FormData): number {
        if (formdata.get(Names.Group) === null) return undefined
        return parseInt(formdata.get(Names.Group).valueOf().toString())
    }

    private getapproaches(formdata: FormData): any {
        if (formdata.get(Names.Approaches) === null) return undefined
        let data = this.state.service ? this.state.service.approaches.length >= 0 ? this.state.service.approaches.map(r => r.id) : [] : []
        let value = parseInt(formdata.get(Names.Approaches).valueOf().toString())
        if (!isNaN(value) && data.indexOf('value') == -1) {
            data = value && [value]
        }
        return data
    }

    private handleChangeServiceBL(e: React.SyntheticEvent<Element>): void {
        const target = e.currentTarget as HTMLSelectElement
        const selectedServiceBL = target.value
        this.setState({ selectedServiceBL })
    }

    private handleSubmit(e: React.SyntheticEvent<Element>): void {
        e.preventDefault()
        this.setState({ submitting: true })

        const form = e.target as HTMLFormElement
        const values = this.getFormValues(form)
        const service = this.state.service

        if (this.state.service) this.updateService(service, values)
        else this.createService(values)
    }

    private initData(props: DetailServiceModalProps): void {
        if (!props.service) return
        if (this.state.serviceLoaded) return

        this.setState({ loadingService: true }, () => {
            ServicesService.findOneService(props.localAuthority, props.service.slug)
                .then(service => this.setState({
                    loadingService: false,
                    service,
                    serviceLoaded: true
                }, () => {
                    this.forcefetchingServiceAgents()
                    if (props.localAuthority.bergerLevrault && props.localAuthority.bergerLevrault.enabled)
                        this.setState({ selectedServiceBL: service.code })
                }))
                .catch(reason => {
                    this.setState({ loadingService: false, serviceLoaded: false })
                    this.props.onError(reason)
                })
        })
    }

    private updateService(service: Service, values: FormValues): void {
        service.code = values.code !== service.code && values.code !== "Associer un service" ? values.code : undefined
        service.description = values.description !== service.description ? values.description : undefined
        service.label = values.label !== service.label ? values.label : undefined
        service.localAuthority = this.props.localAuthority.id
        service.serviceGroup = values.group !== service.serviceGroup ? values.group : undefined
        service.approaches = values.approaches ? values.approaches : []

        ServicesService.updateService(service)
            .then(service => {
                this.setState({ submitting: false })
                this.props.onServiceUpdated(service)
            })
            .catch(reason => {
                this.setState({ submitting: false })
                this.props.onError(reason)
            })
    }
}

export { Names }

export interface DetailServiceModalProps {
    loading: boolean
    localAuthority: LocalAuthority
    groups: ServiceGroup[]
    Politique: any
    service?: Service
    servicesBL: ElementAnalytiqueBergerLevrault[]
    onClose(e: React.SyntheticEvent<Element>): void
    onError(reason: any): void
    onServiceCreated?(service: Service): void
    onServiceUpdated?(service: Service): void
}

interface FormValues {
    code: string
    description: string
    label: string
    group: number
    approaches: any
}

interface State {
    agents: User[]
    agentsLoaded: boolean
    loadingAgents: boolean
    loadingService: boolean
    service: Service
    selectedServiceBL: string
    serviceLoaded: boolean
    submitting: boolean
}



// WEBPACK FOOTER //
// ./src/component/services/detail-service-modal/index.tsx